import { render, staticRenderFns } from "./ExemptionSetting.vue?vue&type=template&id=7daf1163"
import script from "./ExemptionSetting.vue?vue&type=script&lang=js"
export * from "./ExemptionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports